export default (headers: string, lines: string) => {
  return `${headers}\r\nDATA;\r\n${lines.replaceAll(
    '\n',
    ''
  )}\nENDSEC;\nEND-ISO-10303-21;`
}
